import { FileUploadQuestion } from "./file-upload-question";
import type { QuestionTypeRendererProps } from "./shared";

export default function FileUploadQuestionType(props: QuestionTypeRendererProps<"file_upload">) {
  return <FileUploadQuestion {...props} />;
}
